export default __webpack_public_path__ + "static/media/hell_rock.a1886407.png";